// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_7PqFIn","questionAnswer":"ob_DI3dpE","icon":"ob_R2f155"};